import React from "react"

import {
    Container,
    PageContent,
} from "client/components"

import StudyFields from "./studyFields"
import TeamMembersFields from "./teamMembersFields"
import SessionFields from "./sessionFields"

const Study = () => (
    <Container>
        <PageContent>
            <StudyFields />
            <TeamMembersFields />
            <SessionFields />
        </PageContent>
    </Container>
)
export default Study
